import { isIOS, isMobileOnly } from 'react-device-detect';
// @ts-expect-error react-smartbanner has no type declarations
import SmartBanner from 'react-smartbanner';

import 'react-smartbanner/dist/main.css';

const SmartBannerContainer = () => (
  <>
    {!window.native.isNative && isMobileOnly && isIOS && (
      <SmartBanner
        button="Get"
        ignoreIosVersion={true}
        position="top"
        price={{
          ios: 'Download',
          // android: 'Download',
          // windows: 'Download',
          // kindle: 'Download',
        }}
        storeText={{
          ios: 'app',
          // android: 'app',
          // windows: 'app',
          // kindle: 'app',
        }}
        title={'Pathway 2.0'}
        url={{
          ios: 'https://apps.apple.com/us/app/chick-fil-a-pathway-2-0/id1628910112',
          // android:
          //   'https://install.appcenter.ms/orgs/dtt-ots/apps/pathway-1/distribution_groups/operators_and_team_members',
          // windows:
          //   'https://install.appcenter.ms/orgs/dtt-ots/apps/pathway-1/distribution_groups/operators_and_team_members',
          // kindle:
          //   'https://install.appcenter.ms/orgs/dtt-ots/apps/pathway-1/distribution_groups/operators_and_team_members',
        }}
      />
    )}
  </>
);

export default SmartBannerContainer;
